var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-tabs',{staticClass:"md-transparent",attrs:{"md-sync-route":""}},_vm._l((_vm.routes),function(route){return _c('md-tab',{key:route.path,attrs:{"to":_vm.handleToRoute(route),"id":'tab-' + route.path,"md-label":route.name}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }